import { AbstractSearchItemsService } from './abstract-search-items.service';
import { Injectable } from '@angular/core';
import {
    WkfSupervisionSearchItemsAction
} from '../../wkf-supervision-search/wkf-supervision-search-item/action/wkf-supervision-search-items.action';

@Injectable( {
    providedIn: 'root'
} )
export class WkfSupervisionItemsService extends AbstractSearchItemsService {
    constructor(private wkfSupervisionSearchItemsAction : WkfSupervisionSearchItemsAction) {
        super();
    }
    protected getSearchItemsAction(): WkfSupervisionSearchItemsAction {
        return this.wkfSupervisionSearchItemsAction;
    }

}